import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const timelineElement = css`
	display: flex;
	padding-top: 15px;

	.block {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.wrapBlock {
		display: flex;
		align-items: baseline;
		flex-wrap: wrap;
	}

	.form-label {
		margin-bottom: 0;
		font-size: 12px;
		color: #757575;
	}

	.form-group {
		margin-bottom: 5px;
	}

	.select {
		max-width: 100px;
		margin-right: 3px;
	}

	.slideBlock {
		border: 1px solid lightgray;
		border-radius: 4px;
		padding: 20px;

		width: 70%;
		margin-left: 10px;
		margin-top: 29px;

		position: relative;

		.deleteSlideButton {
			position: absolute;
			top: 20px;
			right: 20px;

			:hover {
				color: red;
				cursor: pointer;
			}
		}

		.dateFormatSelect {
			min-width: 200px;
			margin-right: 10px;
			margin-bottom: 5px;
		}

		.datePickerWrapper {
			min-width: 200px;

			input {
				width: 100%;
			}
		}

		.datePicker {
			border: 1px solid ${colors.border};
			padding: 6px;
			border-radius: 4px;
			color: ${colors.mainText};
		}

		.noSlideSelectedBlock {
			display: flex;
			align-items: center;
			justify-content: center;
			min-height: 350px;
			color: ${colors.infoText};
		}

		.additionalFieldsWrapper {
			margin-top: 15px;
		}

		.additionalFieldsHeader {
			color: ${colors.mainText};
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: ${colors.background};

			padding: 6px 12px;
			border: 1px solid ${colors.border};
			border-radius: 4px;
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;

			svg {
				cursor: pointer;
			}
		}

		.additionalFieldsBlock {
			border: 1px solid ${colors.border};
			border-top: none;
			padding: 0 10px 10px 10px;
		}
	}

	.mediaTextArea {
		width: 100%;

		:not(:first-child) {
			margin-left: 10px;
		}
	}

	.title {
		font-weight: 600;
	}
`;

export const slidesPanel = css`
	width: 30%;
	display: flex;
	flex-direction: column;

	.scrollableBlock {
		flex: 1 1 auto;
		height: 0px;
		overflow-y: auto;
		padding: 10px 0;
		border-top: 1px solid lightgray;
		border-bottom: 1px solid lightgray;
	}

	.slideWrapper {
		padding: 5px;
		padding-left: 20px;
		margin-bottom: 10px;
		display: flex;
		position: relative;
		border-radius: 4px;

		:hover {
			background-color: ${colors.background};
			cursor: pointer;
		}
	}

	.slideNumber {
		color: #9b9b9b;
		font-size: 12px;
		position: absolute;
		left: 5px;
		top: 5px;
	}

	.activeSlide {
		border: 1px solid #037bfe24;
		background-color: #037bfe24;

		:hover {
			background-color: #037bfe24;
		}

		.headline {
			border: 1px solid #037bfe24;
		}
	}

	.headline {
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding: 10px;
		width: 100%;

		font-size: 14px;
		background-color: white;
	}

	.titleSlideWrapper {
		min-height: 40px;
	}

	.infoText {
		color: ${colors.infoText};
	}

	.slidesHeaderBlock {
		display: flex;
		align-items: center;
		justify-content: space-between;

		padding: 5px 0;
	}

	.addSlideButton {
		svg {
			color: ${colors.mainText};
		}

		:hover {
			color: ${colors.mainText};
			border: none;
			border-radius: 4px;
			background-color: ${colors.background};
		}

		button:focus {
			outline: 1px auto ${colors.border};
		}
	}

	.label {
		font-size: 12px;
		color: gray;
	}
`;

export const loadDataBlock = css`
	border: 1px solid ${colors.border};
	background-color: ${colors.background};
	border-radius: 4px;
	padding: 0 10px;
	margin-top: 20px;
`;

export const figurePropertiesBlock = css`
	.form-label {
		margin-bottom: 0;
		font-size: 12px;
		color: #757575;
	}

	.form-group {
		margin-bottom: 5px;
	}

	.block {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.figure-number {
		max-width: 150px;
		margin-right: 10px;
	}

	.figure-title {
		width: 100%;
	}
`;
